import store from "../services/store";

const hostname=window.location.hostname.split('.')

const DB_NAME = 'usercontrolweb_'+hostname[0];
const DB_VERSION = 1;
let DB;
let ids=[]

function putCrudLists (id,list,data)
{
	ids['id_'+list]=id
	data.id=id
	
	if(list.includes('list_') || list.includes('datos_'))
	{
		
		let idDatalist = store.state.crudStore.lists[list].findIndex( list => list.id.toString()===data.id.toString() )
		if(idDatalist!=-1)
		{
			store.state.crudStore.lists[list][idDatalist]=data
			
			return true
		}		
		store.state.crudStore.lists[list].push(data)
	}
	return true
}

function createDataGet (dataGet)
{
	store.state.crudStore.dataGet[store.state.crudStore.namePath].data=dataGet
}

export default {
	async getDb() {
		return new Promise((resolve, reject) => {   

			let request = window.indexedDB.open(DB_NAME, DB_VERSION);
			        
			request.onerror = e => {
				console.log('Error opening db', e);
				reject('Error');
			};
	
			request.onsuccess = e => {
				DB = e.target.result;
				resolve(DB);
			};
			
			let tablasBasedatos = Object.keys(store.state.configStore.datadb)

			request.onupgradeneeded = e => {
				let db = e.target.result;
				for (let i = 0; i < tablasBasedatos.length; i++) {
					if(tablasBasedatos[i].includes('list_') || tablasBasedatos[i].includes('datos_') || tablasBasedatos[i].includes('multiple_') || !tablasBasedatos[i].includes('_')  || tablasBasedatos[i]==='ultima_conexion' || tablasBasedatos[i]==='tabla_campos' || tablasBasedatos[i]==='ultima_conexion')
					{
						let datadb = db.createObjectStore(tablasBasedatos[i], { autoIncrement: true, keyPath: 'id' });
						
						let camposBasedatos = Object.keys(store.state.configStore.datadb[tablasBasedatos[i]])
						
						for (let j = 0; j < camposBasedatos.length; j++) {	
								datadb.createIndex(camposBasedatos[j],camposBasedatos[j],{unique: false})				
						}
					}
					
				}
				
			};
		});
    },    
	async saveIdb(data) {		
		let db = await this.getDb();

		let tablasBasedatos = Object.keys(store.state.configStore.datadb)

		if(tablasBasedatos.includes(data.list))
		{
			return new Promise(resolve => {
				let trans = db.transaction([data.list],'readwrite');
				
				trans.oncomplete = () => {
					resolve();
				};   

				let store = trans.objectStore(data.list);

				let array=[]

				if(data.data.length===undefined)
				{
					array.push(data.data)
				}
				else
				{
					array=data.data					
				}
				if(array.length>0)
				{
					for (let i = 0; i < array.length; i++) {

						let camposKeys=Object.keys(array[i])
						let newArray={}

						for (let j = 0; j < camposKeys.length; j++) 
						{		
							if(camposKeys[j]==='id' && array[i][camposKeys[j]]!=='')
							{
								newArray[camposKeys[j]]=array[i][camposKeys[j]]
							}
							else 
							{
								if(camposKeys[j].includes('id_') && array[i][camposKeys[j]]==='')
								{
									newArray[camposKeys[j]]=ids[camposKeys[j]]
								}
								else if(camposKeys[j]!=='id')
								{							
									newArray[camposKeys[j]]=array[i][camposKeys[j]]
								}								
							}							
						}
						let request=store.put(newArray)

						request.onsuccess = function(event) {
							putCrudLists(event.target.result,data.list,newArray)
						};			
					} 
				}           
			});	
		}		
	},
	async deleteIdb(data) {

		let db = await this.getDb();

		return new Promise(resolve => {

			let trans = db.transaction([data.tabla],'readwrite');
			trans.oncomplete = () => {
				resolve();
			};
			
			let store = trans.objectStore(data.tabla);
			
			let deleteStore = store.delete(data.id)

			deleteStore.onsuccess = function (e) {
				resolve()
			};
		});
	},
	
	async getIdb(list) {

		let db = await this.getDb();

		let tablasBasedatos = Object.keys(store.state.configStore.datadb)

		if(tablasBasedatos.includes(list))
		{
			return new Promise(resolve => {

				let trans = db.transaction([list],'readonly');
				trans.oncomplete = () => {
					resolve(lists);
				};
				
				let store = trans.objectStore(list);
				let lists = [];
				
				store.openCursor().onsuccess = e => {
					let cursor = e.target.result;
					if (cursor) {
						lists.push(cursor.value)
						cursor.continue();
					}
				};

			});
		}
	},
	
	async searchGetIdb(data) {

		let db = await this.getDb();
		
		return new Promise(resolve => {

			let trans = db.transaction([data.tabla],'readonly');
			
			let store = trans.objectStore(data.tabla);

			if(data.campo===undefined)
			{
				var request = store.getAll()
			}
			else{
				
				var myIndex = store.index(data.campo); 

				var request = myIndex.getAll(data.value);
			}

			
			
			trans.oncomplete = () => {
				resolve();
			};

			if(data.principal===undefined)
			{
				
				request.onsuccess= async e => {
					let newArray =[]					
					for (let i = 0; i < e.target.result.length; i++) {
						newArray[i]={}						
						newArray[i][data.tabla]=e.target.result[i]
						let objectNewarray = Object.keys(e.target.result[i])
						for (let j = 0; j < objectNewarray.length; j++) {							
							if(objectNewarray[j].includes('id_') && objectNewarray[j]!=='id_list')
							{
								let prueba = await this.searchTabla({tabla: objectNewarray[j].substring(3), campo: 'id', value: e.target.result[i][objectNewarray[j]]})

								newArray[i][objectNewarray[j].substring(3)] = prueba[0]
							}	
						}	
					}
					createDataGet(newArray)
				}
				
			}
			else
			{
				request.onsuccess = async e => {

					let principal={}
					
					for (let i = 0; i < e.target.result.length; i++) {
						
						if(principal[e.target.result[i]['id_'+data.principal]]===undefined)
						{
							principal[e.target.result[i]['id_'+data.principal]]={}
							principal[e.target.result[i]['id_'+data.principal]][data.tabla]=[]
							principal[e.target.result[i]['id_'+data.principal]][data.tabla].push(e.target.result[i])
						}
						else
						{
							principal[e.target.result[i]['id_'+data.principal]][data.tabla].push(e.target.result[i])
						}
					}

					let objectArray = Object.keys(principal)
					let newArray = []

					for (let i = 0; i < objectArray.length; i++) {					
						newArray.push(principal[objectArray[i]])					
					}

					for (let i = 0; i < newArray.length; i++) {
						let objectNewarray = Object.keys(newArray[i][data.tabla][0])
						for (let j = 0; j < objectNewarray.length; j++) {
							if(objectNewarray[j].includes('id_') && objectNewarray[j]!=='id_list')
							{
								let prueba = await this.searchTabla({tabla: objectNewarray[j].substring(3), campo: 'id', value: newArray[i][data.tabla][0][objectNewarray[j]]})

								newArray[i][objectNewarray[j].substring(3)] = prueba[0]
							}						
						}				
					}

					createDataGet(newArray)				
				};
			}			
		});
		
	},

	async buscarIdb(data) {
		return new Promise(async resolve => {
			
			let db = await this.getDb();
			let trans = db.transaction([data.tabla],'readonly');
			
			let store = trans.objectStore(data.tabla);
			
			var myIndex = store.index(data.campo); 

			var getRequest = myIndex.getAll(data.value);
			
			trans.oncomplete = () => {
				resolve();
			};

			getRequest.onsuccess = async e => {			
				resolve(e.target.result)				
			};						
		});
		
	},

	async searchTabla(data) {

		let db = await this.getDb();

		return new Promise(resolve => {

			let trans = db.transaction([data.tabla],'readonly');

			
			let store = trans.objectStore(data.tabla);

			var myIndex = store.index(data.campo); 

			var getRequest = myIndex.getAll(data.value);
			
			trans.oncomplete = () => {
				resolve();
			};

			getRequest.onsuccess = e => {
				resolve(e.target.result);
			};

		});
		
	},

	async deleteDatabase()
	{

		if(hostname[0]==='localhost' || hostname[0]==='nuevo')
		{
			return true
			let db = await this.getDb();			
				db.close();
			
			let promises = await new Promise(resolve => {

				var DBDeleteRequest = window.indexedDB.deleteDatabase(DB_NAME);

				DBDeleteRequest.onblocked = function(event) {	
					db.close();
					resolve(false);
				};

				DBDeleteRequest.onerror = function(event) {
					console.log("Error deleting database.");			
					console.log(event);
				};
				
				DBDeleteRequest.onsuccess = function(event) {
					console.log('success')
					resolve(true);
				};
			});	
						
			if(promises===false)
			{
				this.deleteDatabase()
			}
			else 
			{
				return true
			}
		}
		else 
		{
			return true
		}
		

	}
}